interface NoiseOverlayProps {
  id: string
  opacity?: number
  zIndex?: number
  baseFrequency?: number
  numOctaves?: number
}

export function NoiseOverlay({
  id,
  opacity = 15,
  zIndex = 0,
  baseFrequency = 0.9,
  numOctaves = 4,
}: NoiseOverlayProps) {
  return (
    <svg
      className="absolute size-max inset-0 w-full h-full pointer-events-none"
      style={{ opacity: opacity / 100, zIndex }}
      aria-hidden="true"
    >
      <filter id={id}>
        <feTurbulence
          type="fractalNoise"
          baseFrequency={baseFrequency}
          numOctaves={numOctaves}
        />
        <feColorMatrix type="saturate" values="0" />
      </filter>
      <rect width="100%" height="100%" filter={`url(#${id})`} />
    </svg>
  )
}